/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCalendarMonth/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCalendarMonth({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCalendarMonth",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCalendarMonth.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZE2nCK': alignSelf,'--mt-2-ZE2nCK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZE2nCK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZE2nCK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZE2nCK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZE2nCK': opacity,'--w-10-ZE2nCK': typeof width === 'number' ? `${width}px` : width,'--h-11-ZE2nCK': typeof height === 'number' ? `${height}px` : height,'--a-7-ZE2nCK': isAnimated ? animation : "none",'--sd-8-ZE2nCK': isAnimated ? strokeDashoffset : 0,'--sd-9-ZE2nCK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCalendarMonth.SvgPath"
  data-view-path={viewPath}
 d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
 style={{'--f-12-ZE2nCK': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}